export enum JobPostingCreateInterviewActions {
    fromScratch = 'fromScratch',
    fromExistingInterview = 'fromExistingInterview',
}
